/** Mirrors the developer-mode key that Studio sets, so one switch covers Studio and the canvas. */
export const DEVELOPER_MODE_FLAG = "softr-developer-mode";

/**
 * Gets whether the feature flag is enabled.
 *
 * Persists the enabled feature flag state in `localStorage`.
 */
export function getFeatureFlag(name: string) {
    const params = new URLSearchParams(window.location.search);

    if (!params.has(name)) {
        // Having access to sessionStorage/localStorage depends on the browser's security settings.
        // Certain browsers (e.g. Safari) block access to these APIs in private mode.
        const [enabledInLocalStorage] = attempt(() => localStorage.getItem(name) === "true");
        return !!enabledInLocalStorage;
    }

    if (params.get(name) === "true") {
        attempt(() => localStorage.setItem(name, "true"));
        return true;
    }

    attempt(() => localStorage.removeItem(name));
    return false;
}

type AttemptResult<T> = [value: T, error: undefined] | [value: undefined, error: Error];
/**
 * Executes the provided function and returns the result tuple which contains either the function's return value or an error.
 */
function attempt<T>(fn: () => T): AttemptResult<T> {
    try {
        return [fn(), undefined];
    } catch (err) {
        // @ts-expect-error: Suppressed automatically in TS 5.8 to 6 migration
        return [undefined, err];
    }
}
